import {spawnErrorToast, spawnSuccessToast} from '@hm/fundamental'
import {useQueryClient} from '@tanstack/react-query'
import {useTranslation} from 'react-i18next'

import {mutations} from '@refra/api/mutations'
import {useRefraMutation} from '@refra/modules/common/hooks'
import {logger} from '@refra/modules/common/utils'

export const useEditStaticPartReplacement = () => {
  const {t} = useTranslation()
  const queryClient = useQueryClient()

  return useRefraMutation({
    mutationFn: mutations.editStaticPartReplacement,
    onError: (error) => {
      const errorDetails = error?.response?.data.detail ?? error.message ?? error.response?.status
      logger
        .context('useEditStaticPartReplacement')
        .extras({errorDetails})
        .error('Error occurred while Editing a new replacement for static part')

      spawnErrorToast(t('error.editStaticPartReplacement'))
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({queryKey: ['staticPartReplacement']})
      spawnSuccessToast(t('success.editStaticPartReplacement'))
    }
  })
}
